module.exports = __webpack_public_path__ + "img/198coupon.517dd7ac.png";